import styled, { css } from 'styled-components'
import { RefObject, ChangeEvent } from 'react'
import { filesArrProps } from 'resources/types'
import * as icon from 'ui/icons'
type FileNameProps = {
  handleChangeFileName: (id: string) => (e: ChangeEvent<HTMLInputElement>) => void,
  className?: string,
  file: filesArrProps,
  inputRef: RefObject<HTMLInputElement>
}
const Input = ({ handleChangeFileName, className, file, inputRef }: FileNameProps) => {
  return (
    <input type='text' className={className} spellCheck='false' ref={inputRef} onChange={handleChangeFileName(file.id)} value={file.name} autoFocus />
  )
}
const InputStyled = styled(Input)`${({ theme }) => css`
  width: 100%;
  background-color: #F9FBFF;
  border: none;
  color: ${theme.colors.black};
  font-size: 2.2rem;
  font-family: 'DM Sans',sans-serif;
  margin-left: 1rem;
  caret-color: #AAAFB8;
  :focus  {
    outline: none;
  }
`}`
const FileName = ({ handleChangeFileName, className, file, inputRef }: FileNameProps) => {
  return (
    <label className={className}>
      <icon.FileActive />
      <InputStyled handleChangeFileName={handleChangeFileName} file={file} inputRef={inputRef} />
    </label>
  )
}
const FileNameStyled = styled(FileName)`
  height: 4rem;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  @media(max-width: 1024px){
    margin-bottom: 2rem;
  }
`
export { FileNameStyled as FileName }
